import { render, staticRenderFns } from "./AuthMenuDropdown.vue?vue&type=template&id=09671448&scoped=true&"
import script from "./AuthMenuDropdown.vue?vue&type=script&lang=ts&"
export * from "./AuthMenuDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./AuthMenuDropdown.vue?vue&type=style&index=0&id=09671448&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09671448",
  null
  
)

export default component.exports